<template>
  <div class="ca-pesquisa-filtros gap-size-4 pb-size-5" role="tablist">
    <template v-if="loading">
      <div
        v-for="n in 6"
        :key="n"
        class="ca-pesquisa-filtros__skeleton-pill rounded-circle"
        aria-hidden="true"
      />
    </template>
    <template v-else>
      <button
        v-for="tab in tabs"
        :key="tab.segment"
        class="ca-pesquisa-filtros__pill caption-medium rounded-circle gap-size-3 pt-size-3 pr-size-3 pb-size-3 pl-size-4"
        :class="{ 'is-active': modelValue === tab.segment }"
        role="tab"
        :aria-selected="modelValue === tab.segment"
        @click="$emit('update:modelValue', tab.segment)"
      >
        {{ tab.label }}
        <span
          class="ca-pesquisa-filtros__badge caption-small rounded-circle px-size-2 py-size-1"
          >{{ tab.count }}</span
        >
      </button>
    </template>
  </div>
</template>

<script setup>
defineProps({
  tabs: { type: Array, default: () => [] },
  modelValue: { type: String, default: "todos" },
  loading: { type: Boolean, default: false },
});

defineEmits(["update:modelValue"]);
</script>

<style scoped lang="scss">
.ca-pesquisa-filtros {
  display: flex;
  flex-wrap: wrap;

  &__pill {
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--ca-color-text-light);
    background: var(--ca-color-text-inverted);
    color: var(--ca-color-text-body);
    cursor: pointer;
    white-space: nowrap;
    transition:
      background 0.15s,
      border-color 0.15s;

    &.is-active {
      background: var(--ca-color-hover-pressed-inverted-hover-light);
      border-width: 1.5px;
      border-color: var(--ca-color-hover-pressed-inverted-hover-light);

      .ca-pesquisa-filtros__badge {
        background: var(--ca-color-text-inverted);
      }
    }

    &:hover:not(.is-active) {
      background: var(--ca-color-hover-pressed-container-high-hover);
    }

    &:active:not(.is-active) {
      background: var(--ca-color-hover-pressed-inverted-hover-light);
    }

    &:focus-visible {
      outline: 2px solid var(--ca-color-feedback-info);
      outline-offset: 2px;
      border-radius: 100px;
    }
  }

  &__skeleton-pill {
    height: 40px;
    width: 98px;
    background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 37%, #e8e8e8 63%);
    background-size: 400% 100%;
    animation: shimmer 1.5s infinite;
    flex-shrink: 0;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    background: var(--ca-color-hover-pressed-inverted-hover-light);
    color: var(--ca-color-text-body);
  }
}
</style>
